
export const MESSAGE_CHANGE = 'messages/MESSAGE_CHANGE';
export const messageChange = data => ({
  type: MESSAGE_CHANGE,
  payload: data,
})

export const SUBMIT_INPUT_AREA = 'messages/SUBMIT_INPUT_AREA';
export const submitInputArea = () => ({
  type: SUBMIT_INPUT_AREA,
})

export const START_EDITING_LAST_MESSAGE = 'messages/START_EDITING_LAST_MESSAGE';
export const startEditingLastMessage = nickname => ({
  type: START_EDITING_LAST_MESSAGE,
  payload: nickname,
})

export const SEND_EDITED_MESSAGE = 'messages/SEND_EDITED_MESSAGE';
export const sendEditedMessage = ({ roomId, messageId, text }) => ({
  type: SEND_EDITED_MESSAGE,
  payload: { roomId, messageId, text },
})

export const STOP_EDITING_MESSAGE = 'messages/STOP_EDITING_MESSAGE';
export const stopEditingMessage = () => ({
  type: STOP_EDITING_MESSAGE,
})

export const ADD_PREVIEW_MESSAGE = 'rooms/ADD_PREVIEW_MESSAGE';
export const addPreviewMessage = (links, message, roomId) => ({
  type: ADD_PREVIEW_MESSAGE,
  payload: { message, links },
  meta: { roomId },
})

export const RECEIVE_MESSAGE = 'rooms/RECEIVE_MESSAGE';
export const receiveMessage = (roomId, message, isFake) => ({
  type: RECEIVE_MESSAGE,
  payload: message,
  meta: { roomId, isFake },
})

export const REMOVE_MESSAGE = 'rooms/REMOVE_MESSAGE';
export const removeMessage = (roomId, index) => ({
  type: REMOVE_MESSAGE,
  payload: { roomId, index },
})

export const REMOVE_MESSAGE_BY_ID = 'rooms/REMOVE_MESSAGE_BY_ID';
export const removeMessageById = (roomId, messageId) => ({
  type: REMOVE_MESSAGE_BY_ID,
  payload: { roomId, messageId },
})

export const EDIT_MESSAGE_BY_ID = 'rooms/EDIT_MESSAGE_BY_ID';
export const editMessageById = (roomId, messageId, modCount, lastEditedTime, originalTextHtml, translatedTextHtml) => ({
  type: EDIT_MESSAGE_BY_ID,
  payload: { roomId, messageId, modCount, lastEditedTime, originalTextHtml, translatedTextHtml },
})

export const START_EDITING_MESSAGE = 'rooms/START_EDITING_MESSAGE';
export const startEditingMessage = ({ id, originalText }) => ({
  type: START_EDITING_MESSAGE,
  payload: { id, originalText },
})

export const SEND_MESSAGE = 'rooms/SEND_MESSAGE';
export const sendMessage = (roomId, text) => ({
  type: SEND_MESSAGE,
  payload: text,
  meta: { roomId },
})

export const SAVE_DRAFT_UNREAD_MESSAGES = 'rooms/SAVE_DRAFT_UNREAD_MESSAGES';
export const saveUnreadMessages = (roomId, unreadMessages) => ({
  type: SAVE_DRAFT_UNREAD_MESSAGES,
  payload: { unreadMessages },
  meta: { roomId },
})
